import { useEffect, useRef } from 'preact/hooks'

export function useInView(callback: () => void, enabled: boolean = true) {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!enabled || !ref.current) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          callback()
        }
      },
      { threshold: 0.1 },
    )

    observer.observe(ref.current)

    return () => observer.disconnect()
  }, [callback, enabled])

  return ref
}
